import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import useStore from '../store'
import rollbarLogger from '../utilities/rollbarLogger'

const FORCE_RELOAD_AFTER = 24 * 60 * 60 * 1000

export function useForceReload() {
  const location = useLocation()
  const [startTime, setStartTime] = useState(Date.now())
  const user = useStore((state) => state.user)
  const rollbar = rollbarLogger(user)

  useEffect(() => {
    const now = Date.now()

    if (now - startTime > FORCE_RELOAD_AFTER) {
      rollbar.logInfo('Force reloading app due to inactivity.')
      window.location.reload()
    }
  }, [location, startTime])
}
